import axiosInstance from '../../../../common/axiosInstance';

export const employeeService = {
  // 1. Get All Employees (with pagination/search params)
  getEmployees: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/employees', { params });
      return response.data; 
    } catch (error) {
      console.error('Error fetching employee list:', error);
      throw error;
    }
  },

  // 2. Get Employee by UUID (Full Profile)
  getEmployeeByUuid: async (uuid) => {
    try {
      const response = await axiosInstance.get(`/employees/${uuid}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching employee with UUID ${uuid}:`, error);
      throw error;
    }
  },

  // 3. Get All Documents for an Employee
  getEmployeeDocuments: async (uuid) => {
    try {
      const response = await axiosInstance.get(`/employees/${uuid}/documents`);
      return response.data;
    } catch (error) {
      console.error('Error fetching employee documents:', error);
      return { data: [] }; 
    }
  },

  // 4. Add a New Document for an Employee (POST)
  addEmployeeDocument: async (uuid, documentData) => {
    try {
      const response = await axiosInstance.post(`/employees/${uuid}/documents`, documentData);
      return response.data;
    } catch (error) {
      console.error('Error creating employee document:', error);
      throw error;
    }
  },

  // 5. Get All Contacts for an Employee
  getEmployeeContacts: async (uuid) => {
    try {
      const response = await axiosInstance.get(`/employees/${uuid}/contacts`);
      return response.data;
    } catch (error) {
      console.error('Error fetching employee contacts:', error);
      return { data: [] };
    }
  },

  // 6. Add a New Contact for an Employee (POST)
  addEmployeeContact: async (uuid, contactData) => {
    try {
      const response = await axiosInstance.post(`/employees/${uuid}/contacts`, contactData);
      return response.data;
    } catch (error) {
      console.error('Error creating employee contact:', error);
      throw error;
    }
  },

  // 7. Delete an Employee Contact (DELETE)
  deleteEmployeeContact: async (employeeUuid, contactUuid) => {
    try {
      const response = await axiosInstance.delete(`/employees/${employeeUuid}/contacts/${contactUuid}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting employee contact:', error);
      throw error;
    }
  },

  // --- Employee Address APIs ---
  getEmployeeAddresses: async (uuid) => {
    try {
      const response = await axiosInstance.get(`/employees/${uuid}/addresses`);
      return response.data;
    } catch (error) {
      console.error('Error fetching employee addresses:', error);
      return { data: [] };
    }
  },

  addEmployeeAddress: async (uuid, addressData) => {
    try {
      const response = await axiosInstance.post(`/employees/${uuid}/addresses`, addressData);
      return response.data;
    } catch (error) {
      console.error('Error creating employee address:', error);
      throw error;
    }
  },

  deleteEmployeeAddress: async (employeeUuid, addressUuid) => {
    try {
      const response = await axiosInstance.delete(`/employees/${employeeUuid}/addresses/${addressUuid}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting employee address:', error);
      throw error;
    }
  },

  // --- Employee Skill Assignments APIs ---
  getEmployeeSkillAssignments: async (employeeUuid) => {
    try {
      const response = await axiosInstance.get(`/employees/${employeeUuid}/skill-assignments`);
      return response.data;
    } catch (error) {
      console.error('Error fetching employee skills:', error);
      return { data: [] };
    }
  },

  addEmployeeSkillAssignment: async (employeeUuid, assignmentData) => {
    try {
      const response = await axiosInstance.post(`/employees/${employeeUuid}/skill-assignments`, assignmentData);
      return response.data;
    } catch (error) {
      console.error('Error assigning skill:', error);
      throw error;
    }
  },

  deleteEmployeeSkillAssignment: async (employeeUuid, assignmentUuid) => {
    try {
      const response = await axiosInstance.delete(`/employees/${employeeUuid}/skill-assignments/${assignmentUuid}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting skill assignment:', error);
      throw error;
    }
  },
  // --- Employee Organisation Assignments APIs ---
  getEmployeeOrganisationAssignments: async (employeeUuid) => {
    try {
      const response = await axiosInstance.get(`/employees/${employeeUuid}/organisation-assignments`);
      return response.data;
    } catch (error) {
      console.error('Error fetching organisation assignments:', error);
      return { data: [] };
    }
  },
  // Get All Departments
  getDepartments: async () => {
    try {
      const response = await axiosInstance.get('/departments');
      return response.data;
    } catch (error) {
      console.error('Error fetching departments:', error);
      return { data: [] };
    }
  }
};